import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

import KeyShares from './KeyShares'
import PendingShares from './PendingShares'
import RecoveryContact from './RecoveryContact'

import {
  MAXIMUM_CONTACTS,
  canAddContact,
  contactLimitMessage,
  isRemovalRefused,
  recoveryStrength,
  removalRefusedMessage
} from '../../../lib/recovery'

// Updating an invite moves it to the end of the reducer's collection, which would otherwise make a
// row jump down the list the moment its invitation is sent.
const byOldest = (invites = []) => [...invites].sort((first, second) => new Date(first.createdAt) - new Date(second.createdAt))

const RecoveryContacts = props => {
  const {invites, pendingWraps} = props
  const strength = recoveryStrength({invites, pendingWraps})
  const canAdd = canAddContact(invites)
  const removalRefused = invites.some(invite => isRemovalRefused({invite, invites}))

  return (
    <Stack className='recovery-contacts' component='div'>
      <Typography variant='h4' gutterBottom>Recovery contacts</Typography>
      <PendingShares
        pendingWraps={pendingWraps}
        onFinish={props.finishHandover}
        retry={props.retry}
        wrapped={props.wrapped}
        loading={props.loading}
      />
      <Stack
        className='strength'
        component='div'
        sx={{alignItems: 'center', flexDirection: 'row', justifyContent: 'space-between'}}>
        <Stack className='reading' component='div'>
          <Typography className='headline' variant='body1'>{strength.headline}</Typography>
          <Typography variant='body2'>{strength.detail}</Typography>
        </Stack>
        <KeyShares ready={strength.ready} />
      </Stack>
      <Stack className='contacts' component='div'>
        {
          byOldest(invites).map(invite => (
            <RecoveryContact
              key={invite.id}
              invite={invite}
              invites={invites}
              pendingWraps={pendingWraps}
              sendInvitation={props.sendInvitation}
              removeContact={props.removeContact}
              loading={props.loading}
            />
          ))
        }
      </Stack>
      {
        removalRefused && (
          <Alert className='notice' severity='info'>
            <AlertTitle>These three are your recovery</AlertTitle>
            {removalRefusedMessage(invites)}
          </Alert>
        )
      }
      <Stack className='add' component='div' direction='row'>
        <Button disabled={!canAdd || props.loading} onClick={props.onAdd} variant='outlined'>Add contact</Button>
        <Typography variant='body2'>{invites.length} of {MAXIMUM_CONTACTS} added</Typography>
      </Stack>
      {
        !canAdd && (
          <Alert className='notice' severity='info'>
            <AlertTitle>All five slots are taken</AlertTitle>
            {contactLimitMessage(invites)}
          </Alert>
        )
      }
    </Stack>
  )
}

RecoveryContacts.propTypes = {
  invites: PropTypes.array.isRequired,
  pendingWraps: PropTypes.array,
  onAdd: PropTypes.func.isRequired,
  sendInvitation: PropTypes.func.isRequired,
  removeContact: PropTypes.func.isRequired,
  finishHandover: PropTypes.func.isRequired,
  retry: PropTypes.bool,
  wrapped: PropTypes.number,
  loading: PropTypes.bool
}

export default RecoveryContacts
